export enum ORDER_EXPERIENCES {
  REQUEST = 'REQUEST',
  RMX_LEGACY = 'RMX_LEGACY',
  RMX_UNIVERSAL_LINK = 'RMX_UNIVERSAL_LINK',
  COMMAND_LEGACY = 'COMMAND_LEGACY',
  COMMAND_UNIVERSAL_LINK = 'COMMAND_UNIVERSAL_LINK',
  CEMENT_UNIVERSAL_LINK = 'CEMENT_UNIVERSAL_LINK',
  SIMMA_UNIVERSAL_LINK = 'SIMMA_UNIVERSAL_LINK',
  ARKIK_UNIVERSAL_LINK = 'ARKIK_UNIVERSAL_LINK',
  ADMIXTURE_UNIVERSAL_LINK = 'ADMIXTURE_UNIVERSAL_LINK',
}
